import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import IconButton from './IconButton';

const WildlifeClassSelectorButton = ({title, speciesCount, selected, styleName, onClick}) => (
  <div className={classNames(
      "WildlifeClassSelectorButton",
      `WildlifeClassSelectorButton--${styleName}`,
    )}
  >
    <IconButton
      styleName={classNames(`WildlifeClassSelectorButton__button--${styleName}`, {
        [`WildlifeClassSelectorButton__button--${styleName}--unselected`]: !selected,
        [`WildlifeClassSelectorButton__button--${styleName}--selected`]: selected,
      })}
      onClick={onClick}
    >
      <p className="WildlifeClassSelectorButton__species">
        {`${speciesCount} sp.`}
      </p>
      <p className="WildlifeClassSelectorButton__title">
        {title}
      </p>
    </IconButton>
  </div>
);

WildlifeClassSelectorButton.propTypes = {
  title: PropTypes.string.isRequired,
  speciesCount: PropTypes.number.isRequired,
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default WildlifeClassSelectorButton;



// WEBPACK FOOTER //
// ./src/components/WildlifeClassSelectorButton.js